export const getStoreColors = () => {
  const referrer = window.document.referrer;

  return referrer.includes('hailopay') ? 'hailopay' : 'fundlocal';
}
